module.exports = __webpack_public_path__ + "assets/img/info-btn-1a6cf0b9.png";